import { TCaseContractDetailsForm } from "../../../../domain/codecs/form/CaseContractDetailsForm";

// The local `edited` wins so a handler mid-keystroke does not lose it, which makes this
// list the only route back for a field the server derived. auction_status needs it:
// applyAuctionIntroducerDefault sets it, and omitting it hides the Auction section.
export const mergeSavedContractDetails = (
    response: TCaseContractDetailsForm,
    localEdited: TCaseContractDetailsForm["edited"],
): TCaseContractDetailsForm => ({
    ...response,
    edited: {
        ...localEdited,
        searches_required: response.edited.searches_required,
        introducer_referral_fee_gbp_pence: response.edited.introducer_referral_fee_gbp_pence,
        auction_status: response.edited.auction_status,
    },
});
